module.exports = __webpack_public_path__ + "img/ProfileVision.ecfc5e8c.jpg";